function AppService($uibModalStack) {
    'ngInject';

    return {
        isModalOpen() {
            return !!$uibModalStack.getTop();
        }
    };
}

angular
    .module('BB')
    .service('AppService', AppService);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/app.service.js